import { loadStripe } from '@stripe/stripe-js';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);

export interface Product {
  id: string;
  productId: string;
  name: string;
  description: string;
  price: number;
  image: string;
  images: string[];
  category: string;
  metadata?: Record<string, string>;
}

export interface Category {
  name: string;
  image: string;
  productCount: number;
}

export interface ProductsResponse {
  products: Product[];
  categories: Category[];
  productsByCategory: Record<string, Product[]>;
}

export const fetchProducts = async (): Promise<ProductsResponse> => {
  const response = await fetch(`${API_URL}/products`);
  if (!response.ok) {
    throw new Error('Failed to fetch products');
  }
  return response.json();
};

export const createCheckoutSession = async (priceId: string): Promise<string> => {
  const response = await fetch(`${API_URL}/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ priceId }),
  });

  if (!response.ok) {
    throw new Error('Failed to create checkout session');
  }

  const { sessionId } = await response.json();
  return sessionId;
};

export interface CartItem {
  id: string;
  quantity: number;
  name: string;
  price: number;
  image: string;
}

export const createCartCheckoutSession = async (items: CartItem[]): Promise<string> => {
  const response = await fetch(`${API_URL}/create-cart-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items }),
  });

  if (!response.ok) {
    throw new Error('Failed to create cart checkout session');
  }

  const { sessionId } = await response.json();
  return sessionId;
};
